import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'

import config from '@/modules/banking/config'
import pollTransaction from './pollTransaction'
import { generateProcessId, getProcessIdHeader } from '@/modules/banking/_helpers/generateProcessId'

const { urls } = config

export const startContactSyncPollRequest = (contactId) => {
  const processId = generateProcessId()
  return new Promise((resolve, reject) => {
    request(urls.doContactSync(contactId), {
      auth: true,
      method: 'POST',
      isConcurrent: true,
      headers: {
        ...getProcessIdHeader(processId),
      },
    })
      .then(({ body: { data: transaction } }) => {
        return pollTransaction(transaction, 'bookingApi', processId)
      })
      .then(({ result }) => {
        resolve(result)
      })
      .catch(error => {
        toast.showToast({ error })
        reject(error)
      })
  })
}

export default startContactSyncPollRequest
